// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { decode } from "../config";

const firebaseConfig = {
  apiKey: decode(window._env_?.FIREBASE_API_KEY),
  authDomain: decode(window._env_?.FIREBASE_AUTH_DOMAIN),
  projectId: decode(window._env_?.FIREBASE_PROJECT_ID),
  storageBucket: decode(window._env_?.FIREBASE_STORAGE_BUCKET),
  messagingSenderId: decode(window._env_?.FIREBASE_MESSAGING_SENDER_ID),
  appId: decode(window._env_?.FIREBASE_APP_ID),
  measurementId: decode(window._env_?.FIREBASE_MEASUREMENT_ID),
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();
let analytics;

if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, auth, db, provider, analytics };
